import { useMutation } from '@tanstack/react-query'
import { fetchBillingDetailsPortalSession } from '../subscriptions'

interface UseBillingDetailsPortalProps {
  slug: string
}

export const useBillingDetailsPortal = ({ slug }: UseBillingDetailsPortalProps) => {
  const mutation = useMutation({
    mutationFn: () => fetchBillingDetailsPortalSession({ slug }),
    onSuccess: data => {
      if (!data.url) {
        return
      }
      window.location.href = data.url
    }
  })

  return {
    openBillingDetailsPortal: mutation.mutateAsync,
    isOpeningBillingDetailsPortal: mutation.isPending
  }
}
